import { OralModel } from "../../../../../models/Oral.model"

export type OralQueryModel = {
    actives: OralModel[]
    observations?: string[]
    name: string,
    patient?: number,
    patientIds?: number[]
}

export const toOralConsultation = (name: string, patient: number, observations: string[], actives: OralModel[]) => {
    return {
        name: name,
        actives: actives,
        patient: patient,
        observations: observations,
    } as OralQueryModel
}